import * as actionTypes from "../actions/actionTypes";
import axios from "axios";

const authInitiate = () => {
	return {
		type: actionTypes.AUTH_INITIATE,
	};
};

const authSuccess = (token, userId, refreshToken) => {
	return {
		type: actionTypes.AUTH_SUCCESS,
		token: token,
		userId: userId,
		refreshToken: refreshToken,
	};
};

const checkAuthStatus = () => {
	return (dispatch) => {
		const expirationTime = new Date(localStorage.getItem("expirationTime"));
		const refreshToken = localStorage.getItem("refreshToken");

		const data = {
			grant_type: "refresh_token",
			refresh_token: refreshToken,
		};

		if (expirationTime <= new Date()) {
			axios
				.post(
					"https://securetoken.googleapis.com/v1/token?key=AIzaSyBBL5fAXvlKaBH99vBV3ZRlbRje52-eO5g",
					data
				)
				.then((resp) => {
					const expirationTime = new Date(
						new Date().getTime() + resp.data.expires_in * 1000
					);
					localStorage.setItem("tokMiller", resp.data.id_token);
					localStorage.setItem("userId", resp.data.user_id);
					localStorage.setItem("expirationTime", expirationTime);
					localStorage.setItem("refreshToken", resp.data.refresh_token);
					dispatch(
						authSuccess(
							resp.data.id_token,
							resp.data.user_id,
							resp.data.refresh_token
						)
					);
				})
				.catch((err) => err);
		}
	};
};

export const tryAutoLogin = () => {
	return (dispatch) => {
		const token = localStorage.getItem("tokMiller");
		const refreshToken = localStorage.getItem("refreshToken");
		const userId = localStorage.getItem("userId");
		dispatch(checkAuthStatus());
		if (token) dispatch(authSuccess(token, userId, refreshToken));
	};
};

export const logout = () => {
	localStorage.removeItem("tokMiller");
	localStorage.removeItem("userId");
	localStorage.removeItem("expirationTime");
	localStorage.removeItem("refreshToken");
	return { type: actionTypes.AUTH_LOGOUT };
};

export const authStart = (email, password) => {
	return (dispatch) => {
		const data = {
			email: email,
			password: password,
			returnSecureToken: true,
		};
		dispatch(authInitiate());
		axios
			.post(
				"https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBBL5fAXvlKaBH99vBV3ZRlbRje52-eO5g",
				data
			)
			.then((resp) => {
				const expirationTime = new Date(
					new Date().getTime() + resp.data.expiresIn * 1000
				);
				// console.log(resp.data);
				localStorage.setItem("tokMiller", resp.data.idToken);
				localStorage.setItem("userId", resp.data.localId);
				localStorage.setItem("expirationTime", expirationTime);
				localStorage.setItem("refreshToken", resp.data.refreshToken);
				dispatch(
					authSuccess(
						resp.data.idToken,
						resp.data.localId,
						resp.data.refreshToken
					)
				);
			})
			.catch((err) => err);
	};
};

// sma3797@gmail.com

// 1475963@Ms
